"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsBsKvsEventLog = void 0;
var index_1 = require("../index");
/**
 * 分析登録（イベントログ）
 *
 * @class CsBsKvsEventLog
 */
var CsBsKvsEventLog = /** @class */ (function () {
    /**
     * Creates an instance of CsBsKvsEventLog.
     * @memberof CsBsKvsEventLog
     */
    function CsBsKvsEventLog() {
        // app_id
        this.app_id = 'eventlog';
        // key values リスト
        this.keyValues = [];
        // デフォルトのvalue
        this.defaultValues = {
            serviceName: '01',
            appId: '01',
        };
        // locationパラメータで制御する
        if (index_1.Location.getUrlVars()['debug_eventlog'] == 'true') {
            // 通信を行わない：localStorageにログを保存
            this.csbskvs = new index_1.CsBsKvsDebug();
        }
        else {
            // 通信を行う
            this.csbskvs = new index_1.CsBsKvs();
        }
    }
    /**
     * session_idをセットします
     *
     * @param {string} session_id
     * @memberof CsBsKvsEventLog
     */
    CsBsKvsEventLog.prototype.setSessionId = function (session_id) {
        this.csbskvs.sessionId = session_id;
    };
    /**
     * serviceNameをセットします
     *
     * @param {string} serviceName
     * @memberof CsBsKvsEventLog
     */
    CsBsKvsEventLog.prototype.setServiceName = function (serviceName) {
        this.defaultValues.serviceName = serviceName;
    };
    /**
     * 共通のデータをセット（セットした以降のデータに影響）
     *
     * @param {{ [key: string]: string }} data key_value 値
     * @memberof CsBsKvsEventLog
     */
    CsBsKvsEventLog.prototype.setLogDataCommon = function (data) {
        this.commonValues = data;
    };
    /**
     * 共通のデータを上書きセット：（これまでにセットしたデータに影響）
     *
     * @param {{ [key: string]: string }} data
     * @memberof CsBsKvsEventLog
     */
    CsBsKvsEventLog.prototype.applyLogDataAll = function (data) {
        this.keyValues.forEach(function (keyValue) {
            // 上書き
            Object.assign(keyValue.key_value, data);
        });
    };
    /**
     * ログデータを追加
     *
     * @param {string} dataName data_name 値
     * @param {{ [key: string]: string }} data key_value 値
     * @memberof CsBsKvsEventLog
     */
    CsBsKvsEventLog.prototype.pushLogData = function (dataName, data) {
        // デフォルトのvalueを足す
        data = Object.assign({}, data);
        data = Object.assign(Object.assign({}, this.defaultValues), data);
        if (this.commonValues) {
            // 共通のvalueを足す
            data = Object.assign({}, data);
            data = Object.assign(Object.assign({}, this.commonValues), data);
        }
        // dataのstringチェック
        Object.keys(data).forEach(function (key) {
            if (typeof data[key] != 'string') {
                throw new Error("\u767B\u9332\u3055\u308C\u305F\u30D7\u30ED\u30D1\u30C6\u30A3\u30FC\u201D" + key + "\u201D\u306F\u3001string\u3067\u306F\u3042\u308A\u307E\u305B\u3093\uFF08\u5024\uFF1A" + data[key] + "\uFF09");
            }
        });
        this.keyValues.push({
            data_name: dataName,
            key_value: data,
        });
    };
    /**
     * 登録
     *
     * @param {boolean} [autoClearLogData=true] 登録に成功した場合に、クライアントが保持するデータを削除するかどうか
     * @return {*}  {Promise<void>}
     * @memberof CsBsKvsEventLog
     */
    CsBsKvsEventLog.prototype.post = function (autoClearLogData) {
        if (autoClearLogData === void 0) { autoClearLogData = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (CsBsKvsEventLog.enabled) {
                    return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.csbskvs
                                            .post({
                                            app_id: this.app_id,
                                            key_values: this.keyValues,
                                        })
                                            .then(function () {
                                            // do nothing
                                        })
                                            .catch(function () {
                                            // 続く処理が継続するようエラーcatch
                                        })];
                                    case 1:
                                        _a.sent();
                                        if (autoClearLogData)
                                            this.clearLogData();
                                        resolve();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                }
                else {
                    return [2 /*return*/, new Promise(function (resolve) {
                            resolve();
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * これまでにpushLogDataで登録したログデータを削除します
     *
     * @memberof CsBsKvsEventLog
     */
    CsBsKvsEventLog.prototype.clearLogData = function () {
        this.keyValues = [];
    };
    /**
     * オブジェクトを表す文字列を返します
     *
     * @return {*}  {void}
     * @memberof CsBsKvsEventLog
     */
    CsBsKvsEventLog.prototype.toString = function () {
        return JSON.stringify({
            app_id: this.app_id,
            key_values: this.keyValues,
        }, null, '\t');
    };
    // デバッグモード（trueの場合、通信を行わずlocalStorageにログを記録）
    // static debug = true
    // 有効状態
    CsBsKvsEventLog.enabled = true;
    return CsBsKvsEventLog;
}());
exports.CsBsKvsEventLog = CsBsKvsEventLog;
//# sourceMappingURL=CsBsKvsEventLog.js.map